import React, { useEffect, useState } from "react";
import { Flex, Space, Typography } from "antd";
import { MasterConfigs } from "../../../../../interfaces/entity";
import CustomTabs from "../../../../../components/Tabs";
import ReusableTable from "../../../../../components/TableComponent";
import './../../index.scss';

const Configuration = ({ workerId }) => {
    const [selectedWorkerType, setselectedWorkerType] = useState(workerId)

    const tabs = [
        {
            label: 'Staff',
            key: 'staff',
            content: 'All content'
        },
    ]

    useEffect(() => {
        if (workerId) {
            setselectedWorkerType(workerId)
        }
    }, [workerId])

    const formConfig: MasterConfigs = {
        modalTitle: () => 'Worker Type',
        api: () => `/worker-type/${selectedWorkerType}`,
        combo: [],
        getColumns: () => [
            {
                title: 'Worker Type Name',
                dataIndex: 'name',
                key: 'name',
            },
            {
                title: 'Short Code',
                dataIndex: 'shortCode',
                key: 'shortCode',
            },
            {
                title: 'Description',
                dataIndex: 'description',
                key: 'description',
                width: '30%',
                ellipsis: true,
            },

        ],
    }

    const onTabChange = (key: string) => {
        console.log(key)
    }

    return <>
        <Space direction="vertical" style={{ width: '100%' }} size={[10, 10]}>
            <Flex justify="space-between">
                <CustomTabs
                    tabs={tabs}
                    onTabChange={onTabChange}
                />
            </Flex>
            <ReusableTable config={formConfig} />
        </Space>
    </>
};

export default Configuration;